const Icon = (props: any) => {
    return (
        <svg width={14} height={16} viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M13 15v-1.556a3.17 3.17 0 00-.879-2.2 2.946 2.946 0 00-2.121-.91H4c-.796 0-1.559.327-2.121.91a3.17 3.17 0 00-.879 2.2V15M6.998 7.222c1.657 0 3-1.393 3-3.11 0-1.72-1.343-3.112-3-3.112s-3 1.393-3 3.111c0 1.718 1.343 3.111 3 3.111z"
                stroke="currentColor"
                strokeWidth={1.6}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Icon;
